<template>
  <div class="page flex-col justify-between" :style="{ backgroundImage: `url(${meta.bg})` }">
    <div class="main-wrap flex-col">
      <top-bar />
      <logo />
      <div class="card flex-col">
        <div class="card-title">
          <div class="flex-row justify-center">
            <img
              class="icon" alt=""
              referrerpolicy="no-referrer"
              src="data:application/octet-stream;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAQCAYAAADJViUEAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAD6ADAAQAAAABAAAAEAAAAADlhttaAAAB5UlEQVQoFX1SzUtUURQ/54xNIGPTOOPnKpKCNiHYOlIE/4JaBYFEC0FXBoO6GApxE4PlRoMWgasE3QjiQiFsKbhoF5ZBrkSdZw+kx8y7p9+9w5PLa+jCfefjd37n6z4m7+jK0LXg6OcykY4oc4lV64C/UoYXC/NnG16oUyVxBDOl5/T7OEtMN5XoFqnmIAu4DzXW9WCm60kSm0hH1kp/u1F9WztvTDLzfAL6UjWe9W2rO3JYbwyiUjuTTuez/A3Vty3I6F+ER5nllSrdr5WLH8K54j2L2dNmP7GJB6xEQPEiMhOi/MaQjoGthiViNXZ2UtLxeoPGa+VOJebvrjJa7bWgPYboWX7hdIeZzpBMKI73VPV1E21+sQfG7W3ObEyPB95GMvD40PP9o6KpH46MFroTFHNu6qfHGYB3El8riT2supmJpYrgI7T6K5/NrdYOdl9iwM5WJBS6hP9dfnC46shC3KMqH42Y/iAK36Ppp5jp6jDxCTqqCme+dPTd2Oepw4hoDYNXKhL8WbrEJq9fRacUtPiosHD6OeUmCaOlu/8jYrFhK6JNJA2mB+mMvo1d5IJy6YXvS3TBg40mRivZfFOzHMwVR9K44EHH0s607RLEVE77Bc+zhU263y8N+jaKdPi21f8CPdCx0R+/nDIAAAAASUVORK5CYII="
            />
            <span class="text-group_1">{{ $t('edit_profile["Pet Owner Profile"]') }}</span>
          </div>
        </div>
        <div class="form-label flex-row">
          <img class="form-label-icon" alt="" referrerpolicy="no-referrer"
            src="data:application/octet-stream;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAARCAYAAADUryzEAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAEKADAAQAAAABAAAAEQAAAAAJNVhCAAABi0lEQVQ4EZ1SvUoDQRDeuTsxBgxYWliIFoJgIxYWFgYbUTk8cyCcYKHEF7BQsEjpI1iolQELcxBEbNTGwidIJ4hYWAop4im5HWeO3XUVIodbfTvfz/7MgPi1EBFW/Mo2CtwialLRLRBwctm8OAYAtC1gb4IgGE664kwglu26wQB3BU9sxHH8qmuOBnzyn2YWUjBrWKt9JoCv3fNkrVYhmVbVTIB6sy3tiW2tCSC1/rCeRoswWjvA4vNDO6ClbdSqJ8JtvWesarpktFYAnGqWPvMZXK9Mpl1wnAO3D+aJe9E8z8Q3Vohbs+Sv3ehOkPmdPuuW+pWSpIwoBjMpzcJVs7FAfDZQ5gZc4CERJGAhBQ4IFMtk9G0za7SZdWYgeMOLb/KvUQ7D0O18yj1EuUM5MYDb6HflI4d+pM44SKxIkKuAcDQzPXVYq9Ukc9kNoigqvbU757Rf5GKOdT1UKq7X6/U2ZCcn3Xv6kdkcRiOhkx+KBW/OHR2b2CfzpmHyg5E0xYS7UM3v+amUAqtfIyCZAEdTi94AAAAASUVORK5CYII="/>
          <span class="form-label-text">{{ $t('edit_info["Nickname"]') }}</span>
        </div>
        <input class="ipt-wrap flex-col" v-model.trim="mainForm.userNickname" :placeholder="$t('edit_profile[\'Please enter your nickname\']')" />
        <div class="form-label flex-row">
          <img class="form-label-icon" alt="" referrerpolicy="no-referrer"
            src="data:application/octet-stream;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAEKADAAQAAAABAAAAEAAAAAA0VXHyAAACYUlEQVQ4EX1SS2gTYRCe+bfZBFMSQUFpxddBqiDixUu9eknMstkSaIVCwYMXX/Sk0KugSFWMJ8UHUkkljUk23eK9IIgIUqgYDx4q1VaqlLaUJO3uOLOyYX3UOew/M9/3zT+z8yOwpTLWECANA8E+QHwdQe1ytVp8L1jayOaA8C4gdBLQHBJMqM5YvlYoLAmuUqY1CECPWXyU4wQQndrw3GnDGNglBA06Zlg8jgCjCFjnC654a813p83cCcExZWRnWXxEgrChUiNOtXQtnBM/09fX4254FZYm4lHtmGLxoT9JfkzewSBvGP1dlmXtkbhWKn2IarrBHe1Yb2xeUoiwFhDDJ4KaDWKXmoONDfqcNqyXUqxcfv6RMYcQstLB14AYnDzrJwXJB+041jEGCoY57nWp5ee5gxnm7VUkPyZkiPiMYlqvbT9aDdKTxeL8VLV8m3/gTd5EKpfLJflnR4mg1aEpcFwPzIDMZ32qWFwIxW2XdHUfWt6yruvEyVvrTXqDsi4XmnNEpAuT21qIaInDlcqT5bbyPw6PIo/FynOB8wGPxxh37BcDQWyaQ9tb3spVJp/kNzMPqOWd6sS04H4B6WITmnWeKxmIuMjDbVHtXDwej3z7sfKKseMhzGPf4EscJUnbLizyPs+wSADfuKOz6w337dL31RthsYCMyfaui+93II5YOmNd4Mwdn/ArteVXLuvevTP2WwFhZ8w+03VpjO+Jb6lmgB/gF8cud/sjhIm1SqkSi0APM55yXtb1T1NKXRTgrw7CbNPs39+iZhYJU/yADvCKu/hcVKBGJ+3SPeH+BJoA4zA7LWKQAAAAAElFTkSuQmCC"/>
          <span class="form-label-text">{{ $t('edit_profile["Contact number"]') }}</span>
        </div>
        <div class="ipt-phone-wrap">
          <foreign-area :country-id="temp.countryId" @country="v => (temp.countryId = v)"></foreign-area>
          <input v-model="mainForm.phoneNumber" type="tel" class="ipt-wrap"
                 @input="() => mainForm.phoneNumber = mainForm.phoneNumber.replaceAll(/[^0-9]+/g,'').slice(0,11)"
                 :placeholder="$t('reg[\'Please enter your phone number\']')">
        </div>
        <img class="img-decoration" alt="" referrerpolicy="no-referrer"
          src="@/assets/title_pet.png"/>
      </div>
    </div>
    <div class="btn-save flex-col">
      <div class="text-wrapper_3 flex-col" @click="ajaxUpdate">
        <span class="text_5">{{ $t('base.save') }}</span>
      </div>
    </div>
  </div>
</template>
<script>
import meta from "../../utils/meta";
import foreignArea from "../../components/foreignArea"
import axios from "../../utils/request";

export default {
  components: {
    foreignArea
  },
  data() {
    return {
      meta,
      mainForm: {
        id: meta.user.userId,
        userNickname: meta.user.userName,
        phoneNumber: meta.user.phoneNumber.replace(/^\(\+([0-9]|-)+\)/, '')
      },
      temp: {
        countryId: (foreignArea.data().country[0].options
          .find(county => meta.user.phoneNumber.startsWith(`(+${county.value.split('+')[1].trim()})`)) || {value: 'America +1'}).value
      }
    };
  },
  methods: {
    ajaxUpdate() {
      if (!this.mainForm.userNickname.trim()) {
        this.$message.error(this.$t('reg["Please enter your name"]'))
        return
      }
      if (!this.mainForm.phoneNumber.trim()) {
        this.$message.error(this.$t('reg["Please enter your phone number"]'))
        return
      }

      // 拼接手机号
      const data = structuredClone(this.mainForm)
      data.phoneNumber = `(+${this.temp.countryId.split('+')[1].trim()})${data.phoneNumber}`
      axios({
        url: '/businese/user_info',
        method: 'put',
        data
      }).then(({ code, msg }) => {
        if (code === 200) {
          this.meta.user.userName = data.userNickname.trim()
          this.meta.user.phoneNumber = data.phoneNumber
          this.$router.back()
          return
        }
        this.$message.error(msg)
      })
    }
  },
};
</script>
<style src="@/assets/common.css" scoped />
<style src="./index.css" scoped />



// WEBPACK FOOTER //
// src/views/edit_info/profile.vue